import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function NotFoundPage() {
    return (_jsx("div", { className: "flex min-h-screen items-center justify-center", children: _jsxs("div", { className: "text-center", children: [_jsx("h1", { className: "text-4xl font-semibold", children: "404" }), _jsx("p", { className: "mt-2 text-muted-foreground", children: "Page not found." })] }) }));
}
